import React from "react";
import { Box, Typography } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ModalShell from "./ModalShell";
import { Collection } from "../../../api/derin";
import { collectionColors, font, subtitleSx } from "./tokens";

interface DeactivateCollectionDialogProps {
  open: boolean;
  collection: Collection | null;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

/**
 * Confirmation for deactivating a collection.
 *
 * The toggle used to act on a single click, which is a lot of consequence for one
 * mis-click: deactivating closes every variant to new respondents and submits what has
 * been collected for processing. Activating is not confirmed — it is the reversible
 * direction, and nothing downstream is triggered by it.
 */
const DeactivateCollectionDialog: React.FC<DeactivateCollectionDialogProps> = ({
  open,
  collection,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => (
  <ModalShell
    open={open}
    onClose={onClose}
    title="Deactivate collection"
    subtitle="Deactivating this Collection will end data collection and submit all collected responses for processing. Are you sure you want to deactivate this survey?"
    confirmLabel="Deactivate"
    onConfirm={onConfirm}
    isSubmitting={isSubmitting}
    danger
  >
    {collection && (
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          padding: "12px",
          background: collectionColors.dangerSurface,
          borderRadius: "8px",
        }}
      >
        <WarningAmberOutlinedIcon sx={{ width: 18, height: 18, color: collectionColors.danger, flexShrink: 0 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: font,
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              color: collectionColors.danger,
            }}
          >
            {/* variantCount, not variants.length: the deactivate toggle fires from the
                listing card, whose variant rows are empty until the card is expanded —
                variants.length would read 0 (86bcdw9fp). */}
            {collection.variantCount} variant{collection.variantCount === 1 ? "" : "s"} stop
            accepting responses
          </Typography>
          <Typography sx={{ ...subtitleSx, fontSize: "13px", lineHeight: "18px" }}>
            {collection.name}
          </Typography>
        </Box>
      </Box>
    )}
  </ModalShell>
);

export default DeactivateCollectionDialog;
